/**
 * Firebase Client Configuration
 *
 * Reads from environment variables. Never hardcode keys.
 */

export interface FirebaseClientConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  databaseName: string;
}

export function getFirebaseClientConfig(): FirebaseClientConfig {
  // Vite exposes env vars via import.meta.env with VITE_ prefix
  const env = typeof import.meta !== 'undefined' && import.meta.env
    ? import.meta.env
    : process.env;

  const config: FirebaseClientConfig = {
    apiKey: requireEnv('VITE_FIREBASE_API_KEY', env),
    authDomain: requireEnv('VITE_FIREBASE_AUTH_DOMAIN', env),
    projectId: requireEnv('VITE_FIREBASE_PROJECT_ID', env),
    storageBucket: requireEnv('VITE_FIREBASE_STORAGE_BUCKET', env),
    messagingSenderId: requireEnv('VITE_FIREBASE_MESSAGING_SENDER_ID', env),
    appId: requireEnv('VITE_FIREBASE_APP_ID', env),
    databaseName: (env['VITE_FIREBASE_DATABASE_NAME'] as string) || '(default)',
  };
  return config;
}

function requireEnv(key: string, env: Record<string, unknown>): string {
  const value = env[key] as string | undefined;
  if (!value) {
    throw new Error(`Missing required environment variable: ${key}`);
  }
  return value;
}
